import { render, staticRenderFns } from "./ModalTem.vue?vue&type=template&id=36aa138a&"
import script from "./ModalTem.vue?vue&type=script&lang=js&"
export * from "./ModalTem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports